import { template } from 'lodash';
import { isServer } from '../../helpers/isServer';
const BFF_PATH_PREFIX = 'serp-bff/';
const PRIVATE_BFF_URI_TEMPLATE_NEW = 'https://private-<%= brand %>-<%= brand %>-private-serp-bff.funny-frog-<%= stage %>.aws.aviv-internal.eu';
const PUBLIC_BFF_URI_TEMPLATE_NEW = 'https://public-<%= brand %>.<%= brand %>-public-serp-bff.funny-frog-<%= stage %>.aws.aviv.eu';
export const generateBrandPublicUri = ({ brand, stage, uriTemplate, path }) => {
    const compileUriTemplate = template([uriTemplate, path].filter((item) => item).join('/'));
    // TODO: This exception should be removed later on if immonet is not stupid anymore (Berta is shutdown, or domain without www is routed to AWS)
    if (brand === 'immonet') {
        return compileUriTemplate({
            brand,
            stage: stage === 'live' ? 'www' : `www.${stage}`,
        });
    }
    if (brand === 'logicimmo') {
        return compileUriTemplate({
            brand: 'logic-immo',
            stage: stage === 'live' ? 'www' : stage,
        });
    }
    return compileUriTemplate({
        brand,
        stage: stage === 'live' ? 'www' : stage,
    });
};
export const generateBrandInternalUri = ({ brand, stage }) => {
    const compileUriTemplate = template([PRIVATE_BFF_URI_TEMPLATE_NEW, BFF_PATH_PREFIX].join('/'));
    return compileUriTemplate({
        brand,
        stage,
    });
};
export const generateBrandBffUri = ({ brand, stage, uriTemplate }) => {
    // Handle stage use PRIVATE_BFF_URI for server
    if (isServer()) {
        return generateBrandInternalUri({ brand, stage });
    }
    // Handle local use PUBLIC_BFF_URI for server/client this env is server from the sandbox shell
    if (stage === 'dev') {
        const compileUriTemplate = template(`${PUBLIC_BFF_URI_TEMPLATE_NEW}/${BFF_PATH_PREFIX}`);
        return compileUriTemplate({
            brand,
            stage,
        });
    }
    // Handle stage for client
    return generateBrandPublicUri({ brand, stage, uriTemplate, path: BFF_PATH_PREFIX });
};
